module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/board/plank-bottom-240.png"+" 240w",
        images: [{path: __webpack_public_path__ + "assets/images/board/plank-bottom-240.png",width: 240,height: 16}],
        src: __webpack_public_path__ + "assets/images/board/plank-bottom-240.png",
        toString: function(){return __webpack_public_path__ + "assets/images/board/plank-bottom-240.png"},
        
        width: 240,
        height: 16
      }